// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__1aSxm","info":"UpdateTermsInfo_info__1Hd7n"};